import { FormEvent, useState } from 'react';
import type { CognitoUser } from 'amazon-cognito-identity-js';
import { completeNewPassword, NewPasswordRequiredError, signIn } from '../lib/auth';

type Props = { onOk: () => void };

export function LoginPage({ onOk }: Props) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [pendingUser, setPendingUser] = useState<CognitoUser | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setLoading(true);
    setError(null);
    try {
      if (pendingUser) {
        if (newPassword.length < 8) {
          throw new Error('La nuova password deve avere almeno 8 caratteri.');
        }
        if (newPassword !== confirmPassword) {
          throw new Error('Le due password non coincidono.');
        }
        await completeNewPassword(pendingUser, newPassword);
        onOk();
        return;
      }
      await signIn(email.trim(), password);
      onOk();
    } catch (err) {
      if (err instanceof NewPasswordRequiredError) {
        setPendingUser(err.cognitoUser);
        setError(null);
      } else {
        setError(err instanceof Error ? err.message : String(err));
      }
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="login">
      <form className="login-card" onSubmit={onSubmit}>
        <h1>Supporto Q&amp;S</h1>
        <p>Console ticket · RENTRI · Archiv.IO · Mar.te Privacy</p>
        {error && <div className="error">{error}</div>}
        {!pendingUser ? (
          <>
            <label htmlFor="email">Email</label>
            <input
              id="email"
              type="email"
              autoComplete="username"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <label htmlFor="password">Password</label>
            <input
              id="password"
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </>
        ) : (
          <>
            <p style={{ margin: '0 0 0.75rem', color: '#334155', fontSize: '0.95rem' }}>
              Primo accesso: scegli una nuova password per <strong>{email.trim()}</strong>.
            </p>
            <label htmlFor="newPassword">Nuova password</label>
            <input
              id="newPassword"
              type="password"
              autoComplete="new-password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
              minLength={8}
            />
            <label htmlFor="confirmPassword">Conferma password</label>
            <input
              id="confirmPassword"
              type="password"
              autoComplete="new-password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
              minLength={8}
            />
          </>
        )}
        <button className="btn primary" type="submit" disabled={loading} style={{ width: '100%' }}>
          {loading ? 'Accesso…' : pendingUser ? 'Imposta password' : 'Accedi'}
        </button>
      </form>
    </div>
  );
}
